



































import Vue, { PropType } from 'vue';

import { IBranch, IBranchWithDistance } from '@/types';

import { appStoreMapper } from '@/store/appstore';
import { openUrl, getDistanceBetweenTwoPoints } from '@/misc';
import { getFormattedDistance, checkWorkingTime, getWorkingTimeFormatted } from '@/utils';

export default Vue.extend({
  name: 'BranchList',
  props: {
    from: { type: Number as PropType<number>, default: 0 },
    limit: { type: Number as PropType<number>, default: 0 },
    noTitle: Boolean as PropType<boolean>,
    noDesc: Boolean as PropType<boolean>,
    customBranches: Array as PropType<IBranch[]>,
  },
  computed: {
    branchesList(): IBranchWithDistance[] {
      const origin = this.customBranches ? this.customBranches : this.visibleBranches;

      let branchesWithDistance = origin.map((branch) => {
        let distance =
          this.currentCoords.lat || this.currentCoords.lng
            ? getDistanceBetweenTwoPoints(this.currentCoords, {
                lat: parseFloat(branch.lat),
                lng: parseFloat(branch.lng),
              })
            : 0;
        let formattedDistance = getFormattedDistance(distance, this.$i18n);

        return {
          distance,
          formattedDistance,
          ...branch,
        };
      });

      if (this.currentCoords.lat || this.currentCoords.lng) {
        branchesWithDistance = branchesWithDistance.sort(
          (a, b) => a.distance - b.distance,
        );
      }

      const array = this.from
        ? branchesWithDistance.slice(this.from)
        : branchesWithDistance;
      return this.limit ? array.slice(0, this.limit) : array;
    },
    ...appStoreMapper.mapGetters(['visibleBranches', 'timeZoneOptions']),
    ...appStoreMapper.mapState(['currentCoords']),
  },
  methods: {
    getWorkingTimeFormatted,
    call(link: string, e: Event) {
      openUrl(link, '_system', e);
    },
    contactPhoneFormatted(str: string) {
      let cleaned = ('' + str).replace(/\D/g, '');
      let match = cleaned.match(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/);

      if (match) {
        let intlCode = match[1] ? match[1] : '7';
        return [
          '+',
          intlCode,
          ' ',
          '(',
          match[2],
          ') ',
          match[3],
          '-',
          match[4],
          '-',
          match[5],
        ].join('');
      }

      return '';
    },
    workingTime(branch: IBranchWithDistance) {
      return checkWorkingTime({
        branchOrSchedule: branch,
        timezoneOptions: this.timeZoneOptions,
      });
    },
    pickupTime(branch: IBranchWithDistance) {
      return checkWorkingTime({
        branchOrSchedule: branch,
        timezoneOptions: this.timeZoneOptions,
        type: 'pickup',
      });
    },
  },
});
